<template>
  <div v-loading.fullscreen.lock="isLoading"></div>
</template>
<script>
export default {
  data() {
    return {
      api: require("@/api/ks/mall").default,
      isLoading: false,
    }
  },
  mounted() {
    if (this.$route.query.code) {
      this.isLoading = true;
      var code = this.$route.query.code;
      this.api.codelogin(code).then(res => {
        this.isLoading = false;
        if (res.errorCode) {
          this.$message.error(res.errorMessage);
        } else {
          localStorage.setItem("token", res.accessToken);
          localStorage.setItem("user-info", JSON.stringify({
            mallId: res.mallId,
            mallName: res.mallName,
            userId: res.userId,
            userName: res.userName,
            refreshToken: res.refreshToken,
            secretKey: res.secretKey,
          }));

          this.$router.push("/");
        }
      }).catch(err => {
        this.isLoading = false;
        console.log("err", err);
        // window.location.href = "https://open.kwaixiaodian.com/oauth/authorize?app_id=ks657525547381371328&redirect_uri=https://auth.qunxian.net/KwaiStoresAuth/Index&scope=merchant_refund,merchant_order,user_info,merchant_dropshipping,merchant_item,merchant_servicemarket,merchant_user,merchant_comment,merchant_comment,merchant_logistics&response_type=code";
      })
    } else {
      this.$store.dispatch('clearStorage');
      // window.location.href = "https://open.kwaixiaodian.com/oauth/authorize?app_id=ks657525547381371328&redirect_uri=https://auth.qunxian.net/KwaiStoresAuth/Index&scope=merchant_refund,merchant_order,user_info,merchant_dropshipping,merchant_item,merchant_servicemarket,merchant_user,merchant_comment,merchant_comment,merchant_logistics&response_type=code";
    }
  },
  methods: {

  }
}

</script>